import type { Variant } from '@chessbut/engine';
import { ChessBut, DayBadge, variantStyle } from './Brand.tsx';
import { Modal } from './Modal.tsx';

export { DayBadge };

export function RulesList({ variant }: { variant: Variant }) {
  return (
    <ol className="rules-list">
      {variant.info.rules.map((r, i) => (
        <li key={i}>
          <span className="rule-no">{i + 1}</span>
          <span>{r}</span>
        </li>
      ))}
    </ol>
  );
}

export function RulesModal({ variant, onClose }: { variant: Variant; onClose(): void }) {
  return (
    <Modal title={`How ${variant.info.name} works`} onClose={onClose}>
      <div className="rules" style={variantStyle(variant)}>
        <div className="rules-head">
          <DayBadge variant={variant} />
          <ChessBut variant={variant} as="h3" />
        </div>
        <RulesList variant={variant} />
        <button className="btn primary big block" onClick={onClose}>
          Got it
        </button>
      </div>
    </Modal>
  );
}
